export default __webpack_public_path__ + "static/media/Powerpoint_Symbol_Icon.c157e8e0.svg";